<!-- 
	This is the dashboard page, it uses the dashboard layout in: 
	"./layouts/Dashboard.vue" .
 -->

<template>
	<div>
		<!-- Header -->
		<a-row :gutter="24" type="flex" class="mb-24">
			<a-col :span="24">
				<a-card :bordered="false" class="header-solid h-full">
					<template #title>
						<h5 class="font-semibold">Dashboard</h5>
						<p>Overview of your financial status and recent activity</p>
					</template>
				</a-card>
			</a-col>
		</a-row>

		<!-- Error Alert -->
		<a-alert v-if="error" type="error" :message="error" class="mb-24" show-icon closable />

		<!-- Counter Widgets -->
		<a-spin :spinning="loading">
			<a-row :gutter="24">
				<a-col :span="24" :lg="12" :xl="8" class="mb-24" v-for="(stat, index) in stats" :key="index">
					<!-- Widget 1 Card -->
					<WidgetCounter
						:title="stat.title"
						:value="stat.value"
						:prefix="stat.prefix"
						:suffix="stat.suffix"
						:icon="stat.icon"
						:status="stat.status"
					></WidgetCounter>
					<!-- / Widget 1 Card -->
				</a-col>
			</a-row>
		</a-spin>
		<!-- / Counter Widgets -->

		<!-- Charts -->
		<a-row :gutter="24" type="flex" align="stretch">
			<a-col :span="24" :lg="10" class="mb-24">

			</a-col>
			<a-col :span="24" :lg="24" class="mb-24">
				
				<!-- Financial Overview Card -->
				<CardFinancialChart></CardFinancialChart>
				<!-- / Financial Overview Card -->

			</a-col>
		</a-row>
		<!-- / Charts -->

	</div>
</template>

<script>

	// Bar chart for "Active Users" card.
	import CardBarChart from '../components/Cards/CardBarChart' ;

	// Financial chart for "Monthly Overview" card.
	import CardFinancialChart from '../components/Cards/CardFinancialChart' ;

	// Counter Widgets
	import WidgetCounter from '../components/Widgets/WidgetCounter' ;

	// "Projects" table component.
	import CardProjectTable from '../components/Cards/CardProjectTable' ;

	// Order History card component.
	import CardOrderHistory from '../components/Cards/CardOrderHistory' ;

	// Information card 1.
	import CardInfo from '../components/Cards/CardInfo' ;

	// Information card 2.
	import CardInfo2 from '../components/Cards/CardInfo2' ;

	// "Projects" table list of columns and their properties.
	const tableColumns = [
		{
			title: 'COMPANIES',
			dataIndex: 'company',
			scopedSlots: { customRender: 'company' },
			width: 300,
		},
		{
			title: 'MEMBERS',
			dataIndex: 'members',
			scopedSlots: { customRender: 'members' },
		},
		{
			title: 'BUDGET',
			dataIndex: 'budget',
			class: 'font-bold text-muted text-sm',
		},
		{
			title: 'COMPLETION',
			scopedSlots: { customRender: 'completion' },
			dataIndex: 'completion',
		},
	];

	// "Projects" table list of rows and their properties.
	const tableData = [
		{
			key: '1',
			company: {
				name: 'Soft UI Shopify Version',
				logo: 'images/logos/logo-shopify.svg',
			},
			members: [ "images/face-1.jpg", "images/face-4.jpg", "images/face-2.jpg", "images/face-3.jpg", ],
			budget: '€14,000',
			completion: 60,
		},
		{
			key: '2',
			company: {
				name: 'Progress Track',
				logo: 'images/logos/logo-atlassian.svg',
			},
			members: [ "images/face-4.jpg", "images/face-3.jpg", ],
			budget: '€3,000',
			completion: 10,
		},
		{
			key: '3',
			company: {
				name: 'Fix Platform Errors',
				logo: 'images/logos/logo-slack.svg',
			},
			members: [ "images/face-1.jpg", "images/face-2.jpg", "images/face-3.jpg", ],
			budget: 'Not Set',
			completion: {
				label: '100',
				status: 'success',
				value: 100,
			},
		},
		{
			key: '4',
			company: {
				name: 'Launch new Mobile App',
				logo: 'images/logos/logo-spotify.svg',
			},
			members: [ "images/face-1.jpg", "images/face-2.jpg", ],
			budget: '€20,600',
			completion: {
				label: '100',
				status: 'success',
				value: 100,
			},
		},
		{
			key: '5',
			company: {
				name: 'Add the New Landing Page',
				logo: 'images/logos/logo-jira.svg',
			},
			members: [ "images/face-1.jpg", "images/face-4.jpg", "images/face-2.jpg", "images/face-3.jpg", ],
			budget: '€4,000',
			completion: 80,
		},
		{
			key: '6',
			company: {
				name: 'Redesign Online Store',
				logo: 'images/logos/logo-invision.svg',
			},
			members: [ "images/face-1.jpg", "images/face-4.jpg", "images/face-3.jpg", ],
			budget: '€2,000',
			completion: {
				label: 'Cancelled',
				status: 'exception',
				value: 100,
			},
		},
	];

	import { authFetch, OrganizationManager } from '../auth';

	export default ({
		components: {
			CardBarChart,
			CardFinancialChart,
			WidgetCounter,
			CardProjectTable,
			CardOrderHistory,
			CardInfo,
			CardInfo2,
		},
		data() {
			return {

				// Associating table data with its corresponding property.
				tableData,

				// Associating table columns with its corresponding property.
				tableColumns,

				// Loading and error states
				loading: true,
				error: null,

				// Counter Widgets Stats
				stats: [
					{
						title: "Current Balance",
						value: "—",
						prefix: "€",
						suffix: "",
						icon: `
							<svg width="22" height="22" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M10 2C14.4183 2 18 5.58172 18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2Z" stroke="#111827" stroke-width="1.5" fill="none"/>
								<path d="M12 7H8C7.44772 7 7 7.44772 7 8C7 8.55228 7.44772 9 8 9H10C11.1046 9 12 9.89543 12 11C12 12.1046 11.1046 13 10 13H7" stroke="#111827" stroke-width="1.5" stroke-linecap="round"/>
								<path d="M10 5V7M10 13V15" stroke="#111827" stroke-width="1.5" stroke-linecap="round"/>
							</svg>`,
					},
					{
						title: "Current Month Income",
						value: "—",
						prefix: "€",
						suffix: "",
						icon: `
							<svg width="22" height="22" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M10 17V3M10 3L6 7M10 3L14 7" stroke="#22c55e" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
							</svg>`,
					},
					{
						title: "Current Month Expenses",
						value: "—",
						prefix: "€",
						status: "danger",
						suffix: "",
						icon: `
							<svg width="22" height="22" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M10 3V17M10 17L6 13M10 17L14 13" stroke="#ef4444" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
							</svg>`,
					},
				],
			}
		},
		mounted() {
			this.fetchStats();
		},
		methods: {
			async fetchStats() {
				this.loading = true;
				this.error = null;

				try {
					// Fetch current balance
					const balanceResponse = await authFetch(OrganizationManager.buildOrgUrl('/balance/current'));
					if (!balanceResponse.ok) {
						throw new Error(`Balance API error: ${balanceResponse.status}`);
					}
					const balance = await balanceResponse.json();

					// Fetch current month income
					const incomeResponse = await authFetch(OrganizationManager.buildOrgUrl('/balance/current-month/income'));
					if (!incomeResponse.ok) {
						throw new Error(`Income API error: ${incomeResponse.status}`);
					}
					const income = await incomeResponse.json();

					// Fetch current month expenses
					const expensesResponse = await authFetch(OrganizationManager.buildOrgUrl('/balance/current-month/expenses'));
					if (!expensesResponse.ok) {
						throw new Error(`Expenses API error: ${expensesResponse.status}`);
					}
					const expenses = await expensesResponse.json();

					// Update stats with fetched data
					this.stats[0].value = balance || 0;
					this.stats[1].value = income || 0;
					this.stats[2].value = expenses || 0;

				} catch (error) {
					console.error('Error fetching stats:', error);
					this.error = `Failed to load dashboard data: ${error.message}`;

					// Show error message to user
					this.$notification.error({
						message: 'Data Loading Error',
						description: 'Unable to load dashboard statistics. Please refresh the page or try again later.',
						duration: 5
					});

					// Set error values
					this.stats[0].value = 'Error';
					this.stats[1].value = 'Error';
					this.stats[2].value = 'Error';
				} finally {
					this.loading = false;
				}
			}
		},
	})

</script>

<style lang="scss">
</style>